import './RegionSelector2Modal.css';

import React from 'react';
import { Modal, Button } from '@vtblife/uikit';
import classname from '@search/classname/src';
import Breadcrumb from '@search/vtbeco-ui/src/components/Breadcrumb';

import { RegionSelector2List } from './RegionSelector2List';
import { RegionSelector2Input } from './RegionSelector2Input';
import { useRegionSelector2Modal } from './useRegionSelector2Modal';
import type { RegionSelector2Item } from './RegionSelector2Item';

const cn = classname.bind(null, 'RegionSelector2Modal');

export function RegionSelector2Modal({
    selectedIdInitial,
    items,
    onSelectId,
    onClose,
    hasEmptySelect,
    isMobile
}: {
    isMobile?: boolean;
    onSelectId?(id: RegionSelector2Item['id']): void;
    onClose?(): void;
    items: ReadonlyMap<RegionSelector2Item['id'], RegionSelector2Item>;
    selectedIdInitial?: RegionSelector2Item['id'];
    hasEmptySelect?: boolean;
}) {
    const {
        breadcrumbs,
        setSelectedId,
        onSubmit,
        getVariants,
        actual,
        current
    } = useRegionSelector2Modal({
        selectedIdInitial,
        items,
        hasEmptySelect,
        onSelectId
    });

    const submitButton = (
        <Button
            fullWidth
            variant='primary'
            size='s'
            disabled={! hasEmptySelect ? ! current : false}
            dataTest='show'
            onClick={e => {
                e.preventDefault();
                onSubmit();
            }}
            children='Показать'
        />
    );

    return (
        <Modal
            onClose={onClose}
            closable
            mobile={isMobile}
            opened
            size='xl'
        >
            {isMobile && (<Modal.Header>
                <h3 className={cn('title')}>Выберите регион или город</h3>
            </Modal.Header>)}
            <div className={cn('wideContent')}>
                <div className={cn('items')}>
                    {! isMobile && (<h3 className={cn('title')}>Выберите регион или город</h3>)}
                    <Breadcrumb
                        allClickable
                        sections={breadcrumbs}
                        regionModalSelect
                        onClick={(e, href, section) => {
                            e.preventDefault();
                            setSelectedId(section.key ? Number(section.key) : undefined);
                        }}
                    />
                    <RegionSelector2Input
                        setSelectedId={id => {
                            setSelectedId(id);
                            if (id) onSubmit(id);
                        }}
                        valueInitial={current?.displayName ?? undefined}
                        getVariants={getVariants}
                    >
                        {! isMobile && submitButton}
                    </RegionSelector2Input>
                </div>
                <div className={cn('scroller')} data-scroll-lock-ignore>
                    {actual.primary.length > 0 && (<div className={cn('list')}>
                        {actual.primary.map(item => (<button
                            key={item.id}
                            className={cn('list-item')}
                            children={item.displayName}
                            data-test='main-region-item'
                            onClick={e => {
                                e.preventDefault();
                                setSelectedId(item.id);
                            }}
                        />))}
                    </div>)}
                    <RegionSelector2List
                        items={actual.secondary}
                        setSelectedId={setSelectedId}
                    />
                </div>
                {isMobile && (
                    <div className={cn('submit')}>
                        {submitButton}
                    </div>
                )}
            </div>
        </Modal>
    );
}
